import { styled } from '../../../../styles';
import { FormControl } from '../../../Form/FormControl';

export const StyledFormControl = styled(FormControl)`
  // Override SecondaryLabels code styles for selected value.
  [data-test='selected-value'],
  [data-test='rich-text-presenter'] {
    .code {
      margin-left: 0.5rem;
    }
  }
`;
